<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light"
    id="ftco-navbar"
  >
    <div class="container">
      <a class="navbar-brand" href="/">Kigali Airport<span> Pick Up</span></a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#ftco-nav"
        aria-controls="ftco-nav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="oi oi-menu"></span> Menu
      </button>

      <div class="collapse navbar-collapse" id="ftco-nav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active">
            <a href="/" class="nav-link">Home</a>
          </li>
          <li class="nav-item">
            <a href="/about" class="nav-link">About</a>
          </li>
          <li class="nav-item">
            <a href="/cars" class="nav-link">Our Cars</a>
          </li>
          <li class="nav-item">
            <a href="/blog" class="nav-link">Blog</a>
          </li>
          <li class="nav-item">
            <a href="/contact" class="nav-link">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- END nav -->

  <div
    class="hero-wrap"
    :style="{ backgroundImage: `url('${images[currentImageIndex]}')` }"
    data-stellar-background-ratio="0.5"
  >
    <div class="overlay"></div>
    <div class="container">
      <div
        class="row no-gutters slider-text justify-content-start align-items-center"
      >
        <div class="col-lg-6 col-md-6 d-flex align-items-end">
          <div class="text">
            <h1 class="mb-4">
              <span>Comfortable</span>
              <span>Airport Pick up</span>
            </h1>
            <a
              href="#vimeoModal"
              data-bs-toggle="modal"
              class="icon-wrap d-flex align-items-center mt-4"
            >
              <div
                class="icon d-flex align-items-center justify-content-center"
              >
                <span class="ion-ios-play"></span>
              </div>
              <div class="heading-title ml-5">
                <span>Let's pick up you and visit Rwanda with US</span>
              </div>
            </a>
          </div>
        </div>
        <div class="col-lg-2 col"></div>
        <div class="col-lg-4 col-md-6 mt-0 mt-md-5 d-flex">
          <form @submit.prevent="findVehicle" class="request-form">
            <h2>Plan Your Trip</h2>

            <div class="form-group">
              <label class="label">Pick-up Location</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter city, airport, or station"
                v-model="tripDetails.pickupLocation"
                required
              />
            </div>

            <div class="form-group">
              <label class="label">Drop-off Location</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter destination"
                v-model="tripDetails.dropoffLocation"
                required
              />
            </div>

            <div class="d-flex">
              <div class="form-group mr-2">
                <label class="label">Pick-up Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="tripDetails.pickupDate"
                  required
                />
              </div>

              <div class="form-group ml-2">
                <label class="label">Drop-off Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="tripDetails.dropoffDate"
                  required
                />
              </div>
            </div>

            <div class="form-group">
              <label class="label">Pick-up Time</label>
              <input
                type="time"
                class="form-control"
                v-model="tripDetails.pickupTime"
                required
              />
            </div>

            <div class="form-group">
              <button type="submit" class="btn btn-primary py-3 px-4">
                Find a Vehicle
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
<div
  class="modal fade"
  id="vimeoModal"
  tabindex="-1"
  aria-labelledby="vimeoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content rounded-0">
      <div class="modal-header">
        <h5 class="modal-title" id="vimeoModalLabel">Let's Visit Rwanda with us</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body p-0">
        <div class="ratio ratio-16x9">
          <video
            id="vimeoVideo"
            src="images/visitrwanda-2.mp4"
            autoplay
            muted
            loop
            playsinline
            class="w-100 h-100"
            style="cursor: pointer"
          ></video>
        </div>
      </div>
    </div>
  </div>
</div>
  <section class="ftco-section ftco-no-pb ftco-no-pt">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="search-wrap-1 mb-5">
            <div ref="searchForm" class="search-container">
              <form
                @submit.prevent="searchCars"
                :class="{ sticky: isSticky }"
                class="search-property-1"
              >
                <div class="row">
                  <!-- Select Car Model -->
                  <div class="col-lg align-items-end">
                    <div class="form-group">
                      <label>Select Car Model</label>
                      <div class="form-field">
                        <select v-model="selectedCarModel" class="form-control">
                          <option value="all">All</option>
                          <option
                            v-for="car in originalCars"
                            :key="car.name"
                            :value="car.name"
                          >
                            {{ car.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Select Year Model -->
                  <div class="col-lg align-items-end">
                    <div class="form-group">
                      <label>Year Model</label>
                      <div class="form-field">
                        <select v-model="selectedYear" class="form-control">
                          <option value="">All Years</option>
                          <option
                            v-for="year in carYears"
                            :key="year"
                            :value="year"
                          >
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Select Price Limit -->
                  <div class="col-lg align-items-end">
                    <div class="form-group">
                      <label>Price Limit</label>
                      <div class="form-field">
                        <select v-model="selectedPrice" class="form-control">
                          <option value="">All Prices</option>
                          <option
                            v-for="price in uniquePrices"
                            :key="price"
                            :value="price"
                          >
                            From ${{ price }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Search Button -->
                  <div class="col-lg align-self-end">
                    <div class="form-group">
                      <div class="form-field">
                        <input
                          type="submit"
                          value="Search"
                          class="form-control btn btn-primary"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="ftco-section services-section ftco-no-pt ftco-no-pb">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12 heading-section text-center mb-5">
          <span class="subheading">Our Services</span>
          <h2 class="mb-2">What We Offer</h2>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services">
            <div class="media-body py-md-4">
              <div class="d-flex mb-3 align-items-center">
                <div class="icon">
                  <span class="flaticon-customer-support"></span>
                </div>
                <h3 class="heading mb-0 pl-3">24/7 Customer Support</h3>
              </div>
              <p>
                We provide round-the-clock assistance to ensure a smooth and
                stress-free ride.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services">
            <div class="media-body py-md-4">
              <div class="d-flex mb-3 align-items-center">
                <div class="icon"><span class="flaticon-route"></span></div>
                <h3 class="heading mb-0 pl-3">Multiple Pick-Up Locations</h3>
              </div>
              <p>
                We offer pick-ups and drop-offs at various locations across
                Kigali for your convenience.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services">
            <div class="media-body py-md-4">
              <div class="d-flex mb-3 align-items-center">
                <div class="icon">
                  <span class="flaticon-online-booking"></span>
                </div>
                <h3 class="heading mb-0 pl-3">Easy Online Booking</h3>
              </div>
              <p>
                Book your ride effortlessly through our website and get instant
                confirmations.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services">
            <div class="media-body py-md-4">
              <div class="d-flex mb-3 align-items-center">
                <div class="icon"><span class="flaticon-rent"></span></div>
                <h3 class="heading mb-0 pl-3">Affordable Rental Cars</h3>
              </div>
              <p>
                Choose from a wide range of cars available for rental at
                competitive rates.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="ftco-section" id="vehicle">
    <div class="container-fluid px-4">
      <div class="row justify-content-center">
        <div class="col-md-12 heading-section text-center mb-5">
          <span class="subheading">What we offer</span>
          <h2 class="mb-2">Choose Your Car</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3" v-for="car in cars" :key="car.name">
          <div class="car-wrap">
            <div
              class="img d-flex align-items-end"
              :style="{ backgroundImage: `url(${car.image})` }"
              :aria-label="`${car.name} for hire in Kigali Rwanda – airport transfer and car rental`"
              role="img"
            >
              <div class="price-wrap d-flex">
              </div>
            </div>
            <div class="text p-4 text-center">
              <h2 class="mb-0">
                <router-link
                  :to="'/book/' + car.name.replace(/\s+/g, '-')"
                  @click="saveCarDetails(car)"
                  :title="`Book ${car.name} – Kigali Airport Transfer & Car Rental Rwanda`"
                >
                  {{ car.name }}
                </router-link>
              </h2>
              <span>{{ car.year }}</span>
              <p class="d-flex mb-0 d-block">
                <router-link
                  :to="'/book/' + car.name.replace(/\s+/g, '-')"
                  class="btn btn-black btn-outline-black mr-1"
                  @click="saveCarDetails(car)"
                >
                  Book now
                </router-link>
                <router-link
  :to="'/book/' + car.name.replace(/\s+/g, '-')"
  class="btn btn-black btn-outline-black ml-1 d-flex align-items-center justify-content-center"
  style="width: 40px; height: 40px; padding: 0;"
  title="Contact on WhatsApp"
>
  <i class="fab fa-whatsapp" style="font-size: 50px; color: green;"></i>
</router-link>

              </p>
            </div>
          </div>
        </div>
        <!-- Show message if no cars found -->
        <div v-if="cars.length === 0" class="col-12 text-center">
          <p>
            No cars found From this filter. Try adjusting your search criteria.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section
    class="ftco-section services-section img"
    style="background-image: url(images/Kigali-International-Airport.jpg)"
  >
    <div class="overlay"></div>
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 text-center heading-section heading-section-white">
          <span class="subheading">Work Flow</span>
          <h2 class="mb-3">How It Works</h2>
        </div>
      </div>
      <div class="row">
        <!-- Step 1: Pick Destination -->
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services services-2">
            <div class="media-body py-md-4 text-center">
              <div
                class="icon d-flex align-items-center justify-content-center"
              >
                <span class="flaticon-route"></span>
              </div>
              <div class="card">
                <div class="card-body">
                  <h3 style="color: black">Pick Destination</h3>
                  <p style="color: black">
                    Start by selecting your pick-up and drop-off locations
                    within Kigali or other destinations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 2: Select Term -->
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services services-2">
            <div class="media-body py-md-4 text-center">
              <div
                class="icon d-flex align-items-center justify-content-center"
              >
                <span class="flaticon-select"></span>
              </div>
              <div class="card">
                <div class="card-body">
                  <h3 style="color: black">Select Term</h3>
                  <p style="color: black">
                    Choose whether you need a one-way trip, round trip, or
                    hourly rental based on your travel needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 3: Choose A Car -->
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services services-2">
            <div class="media-body py-md-4 text-center">
              <div
                class="icon d-flex align-items-center justify-content-center"
              >
                <span class="flaticon-rent"></span>
              </div>
              <div class="card">
                <div class="card-body">
                  <h3 style="color: black">Choose A Car</h3>
                  <p style="color: black">
                    Browse our fleet and select a car that suits your budget and
                    preferences for a comfortable ride.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 4: Enjoy The Ride -->
        <div class="col-md-3 d-flex align-self-stretch">
          <div class="media block-6 services services-2">
            <div class="media-body py-md-4 text-center">
              <div
                class="icon d-flex align-items-center justify-content-center"
              >
                <span class="flaticon-review"></span>
              </div>
              <div class="card">
                <div class="card-body">
                  <h3 style="color: black">Enjoy The Ride</h3>
                  <p style="color: black">
                    Relax and enjoy your trip with our professional drivers and
                    well-maintained vehicles.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <br />

  <section class="ftco-section ftco-no-pt ftco-no-pb">
    <div class="container">
      <div class="row no-gutters">
        <!-- Image Section -->
        <div
          class="col-md-6 p-md-5 img img-2 d-flex justify-content-center align-items-center"
          style="background-image: url(images/kcrselfdrive.webp)"
        ></div>

        <!-- Content Section -->
        <div class="col-md-6 wrap-about py-md-5">
          <div class="heading-section mb-5 pl-md-5">
            <span class="subheading">About Us</span>
            <h3 class="mb-4">
              Providing quality Car Airport Pickup with optional accommodation
              services
            </h3>

            <p>
              Kigali Airport Pick Up is your trusted partner for seamless
              airport transfers, ensuring a smooth and stress-free journey from
              Kigali International Airport to your destination. We specialize in
              punctual and professional pick-up and drop-off services, catering
              to both locals and international travelers.
            </p>
            <p>
              Whether you're arriving for business, tourism, or a quick getaway,
              we provide a **fleet of well-maintained vehicles** to suit your
              travel needs. Our professional drivers are trained to offer safe,
              comfortable, and efficient Pick Up, ensuring you reach your
              destination on time.
            </p>

            <p>
              We pride ourselves on **affordable pricing, 24/7 availability, and
              easy online booking**, making airport transfers hassle-free.
              Choose Kigali Airport Pick Up for a reliable and comfortable ride
              every time.
            </p>

            <p><a href="#vehicle" class="btn btn-primary">Search Vehicle</a></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Stats / Trust Signals Section -->
  <section class="ftco-section ftco-no-pb ftco-no-pt py-5" style="background: #2d2d2d; color:#fff;">
    <div class="container">
      <div class="row text-center">
        <div class="col-md-3 col-6 mb-4 mb-md-0">
          <div>
            <h2 class="mb-0" style="font-size:2.5rem; font-weight:800; color:#f5a623;">500+</h2>
            <p class="mb-0" style="font-size:0.95rem; text-transform:uppercase; letter-spacing:1px;">Happy Clients</p>
          </div>
        </div>
        <div class="col-md-3 col-6 mb-4 mb-md-0">
          <div>
            <h2 class="mb-0" style="font-size:2.5rem; font-weight:800; color:#f5a623;">15+</h2>
            <p class="mb-0" style="font-size:0.95rem; text-transform:uppercase; letter-spacing:1px;">Vehicles in Fleet</p>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div>
            <h2 class="mb-0" style="font-size:2.5rem; font-weight:800; color:#f5a623;">24/7</h2>
            <p class="mb-0" style="font-size:0.95rem; text-transform:uppercase; letter-spacing:1px;">Availability</p>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div>
            <h2 class="mb-0" style="font-size:2.5rem; font-weight:800; color:#f5a623;">5★</h2>
            <p class="mb-0" style="font-size:0.95rem; text-transform:uppercase; letter-spacing:1px;">Rated Service</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="accommodation" class="ftco-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12 heading-section text-center mb-5">
          <span class="subheading">Hotel Booking in Kigali & Rwanda</span>
          <h2 class="mb-2">We Help You Book the Best Hotels in Rwanda</h2>
          <p class="text-muted">From budget guesthouses to luxury hotels — we find accommodation that fits your needs and budget.</p>
        </div>
      </div>
      <div class="accommodation-options">
        <div
          v-for="option in accommodations"
          :key="option.type"
          class="accommodation-card"
        >
          <h3>{{ option.type }}</h3>
          <p>{{ option.description }}</p>
          <p><strong>Price:</strong> {{ option.price }}</p>
          <button
            type="button"
            @click="selectAccommodation(option.type)"
            class="btn btn-primary float-right"
          >
            Select
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="ftco-section">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 heading-section text-center">
          <span class="subheading">Blog</span>
          <h2>Recent Blog</h2>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-md-4 d-flex">
          <div class="blog-entry justify-content-end">
            <a
              href="#"
              class="block-20"
              style="
                background-image: url('images/Kigali-International-Airport.jpg');
              "
            >
            </a>
            <div class="text pt-4">
              <div class="meta mb-3">
                <div><a href="#">July. 24, 2025</a></div>
                <div><a href="#">Admin</a></div>
                <div>
                  <a href="#" class="meta-chat"
                    ><span class="icon-chat"></span> 3</a
                  >
                </div>
              </div>
              <h3 class="heading mt-2">
                <a href="#"
                  >A Seamless Journey: Your Ultimate Guide to Kigali Airport
                  Transfers</a
                >
              </h3>
              <p>
                This blog can focus on the convenience and benefits of
                pre-booking airport transfer services, including how travelers
                can save time and avoid the stress of finding transportation
                upon arrival.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="blog-entry justify-content-end">
            <a
              href="#"
              class="block-20"
              style="background-image: url('images/kigali-airport.jpg')"
            >
            </a>
            <div class="text pt-4">
              <div class="meta mb-3">
                <div><a href="#">July. 24, 2025</a></div>
                <div><a href="#">Admin</a></div>
                <div>
                  <a href="#" class="meta-chat"
                    ><span class="icon-chat"></span> 3</a
                  >
                </div>
              </div>
              <h3 class="heading mt-2">
                <a href="#"
                  >Top 5 Things to Do in Kigali After Your Airport Pickup</a
                >
              </h3>
              <p>
                This blog can highlight the key attractions and activities in
                Kigali that visitors should experience, from cultural sites to
                great restaurants, once they've been picked up from the airport.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="blog-entry">
            <a
              href="#"
              class="block-20"
              style="background-image: url('images/Volcanoes-np-1.jpg')"
            >
            </a>
            <div class="text pt-4">
              <div class="meta mb-3">
                <div><a href="#">July. 24, 2024</a></div>
                <div><a href="#">Admin</a></div>
                <div>
                  <a href="#" class="meta-chat"
                    ><span class="icon-chat"></span> 3</a
                  >
                </div>
              </div>
              <h3 class="heading mt-2">
                <a href="#"
                  >How Kigali Airport Pickup Services Contribute to Sustainable
                  Tourism</a
                >
              </h3>
              <p>
                A blog discussing how the airport transport service is
                eco-friendly, focusing on the use of energy-efficient vehicles
                or carbon offset programs. It could also highlight the
                importance of promoting sustainable tourism in Rwanda.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FAQ Section (boosts SEO with FAQ rich results) -->
  <section class="ftco-section" style="background:#fff;">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 text-center heading-section">
          <span class="subheading">Got Questions?</span>
          <h2 class="mb-2">Frequently Asked Questions</h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="accordion" id="faqAccordion">

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq1">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer1" aria-expanded="true" aria-controls="faqAnswer1">
                  How do I book a Kigali airport pickup?
                </button>
              </h3>
              <div id="faqAnswer1" class="accordion-collapse collapse show" aria-labelledby="faq1" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  Booking is easy — use the trip planning form at the top of this page, click "Book Now" on any car, or contact us directly via WhatsApp at <strong>+250 788 613 968</strong>. We confirm your booking instantly.
                </div>
              </div>
            </div>

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq2">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer2" aria-expanded="false" aria-controls="faqAnswer2">
                  How much does a Kigali airport transfer cost?
                </button>
              </h3>
              <div id="faqAnswer2" class="accordion-collapse collapse" aria-labelledby="faq2" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  Rates start from <strong>$25 per trip</strong> depending on the vehicle type and distance. Visit our <a href="/pricing">Pricing page</a> for full rate tables including hourly, daily, and leasing options.
                </div>
              </div>
            </div>

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq3">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer3" aria-expanded="false" aria-controls="faqAnswer3">
                  Do you operate 24 hours a day, 7 days a week?
                </button>
              </h3>
              <div id="faqAnswer3" class="accordion-collapse collapse" aria-labelledby="faq3" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  Yes! We operate <strong>24/7, 365 days a year</strong> — including nights, weekends, and public holidays. No matter when your flight lands, we will be there.
                </div>
              </div>
            </div>

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq4">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer4" aria-expanded="false" aria-controls="faqAnswer4">
                  Can I rent a car in Kigali without a driver?
                </button>
              </h3>
              <div id="faqAnswer4" class="accordion-collapse collapse" aria-labelledby="faq4" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  Yes, self-drive car rental is available. We offer both self-drive and chauffeured options. A valid international driver's licence is required for self-drive hire.
                </div>
              </div>
            </div>

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq5">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer5" aria-expanded="false" aria-controls="faqAnswer5">
                  Which airport do you serve in Rwanda?
                </button>
              </h3>
              <div id="faqAnswer5" class="accordion-collapse collapse" aria-labelledby="faq5" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  We primarily serve <strong>Kigali International Airport (KGL)</strong>. We also provide transfers from Kigali to other destinations including Volcanoes National Park, Nyungwe, Lake Kivu and more.
                </div>
              </div>
            </div>

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq6">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer6" aria-expanded="false" aria-controls="faqAnswer6">
                  What vehicles are available for gorilla trekking trips?
                </button>
              </h3>
              <div id="faqAnswer6" class="accordion-collapse collapse" aria-labelledby="faq6" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  For gorilla trekking and safari trips we recommend our <strong>Land Cruiser V8, Land Cruiser Prado</strong> or <strong>Toyota Hiace Van</strong> for groups. These 4WD vehicles handle Rwanda's mountain terrain with ease.
                </div>
              </div>
            </div>

            <div class="accordion-item mb-3" style="border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
              <h3 class="accordion-header" id="faq7">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqAnswer7" aria-expanded="false" aria-controls="faqAnswer7">
                  Do you help with hotel booking in Kigali?
                </button>
              </h3>
              <div id="faqAnswer7" class="accordion-collapse collapse" aria-labelledby="faq7" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  Yes! We offer <strong>hotel booking assistance</strong> for all budgets – affordable guesthouses, mid-range hotels, and luxury stays in Kigali and across Rwanda. Tell us your budget via WhatsApp and we'll find the best option for you.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Testimonials / Reviews Section -->
  <section class="ftco-section testimonials-section" style="background: #f8f9fa;">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 text-center heading-section">
          <span class="subheading">What Clients Say</span>
          <h2 class="mb-2">Trusted by Travelers Worldwide</h2>
          <p class="text-muted">Over 500 satisfied clients across Rwanda and beyond.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 mb-4">
          <div class="testimonial-card p-4 h-100" style="background:#fff; border-radius:12px; box-shadow:0 2px 16px rgba(0,0,0,0.07);">
            <div class="mb-3" style="color:#f5a623; font-size:18px;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <p style="font-style:italic;">"Excellent service! The driver was at the airport on time and the car was spotless. Highly recommend for anyone visiting Kigali."</p>
            <div class="mt-3 d-flex align-items-center">
              <div style="width:44px;height:44px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;color:#666;margin-right:12px;">J</div>
              <div>
                <strong>James M.</strong><br>
                <small class="text-muted">Business Traveler, UK</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="testimonial-card p-4 h-100" style="background:#fff; border-radius:12px; box-shadow:0 2px 16px rgba(0,0,0,0.07);">
            <div class="mb-3" style="color:#f5a623; font-size:18px;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <p style="font-style:italic;">"Booked a Land Cruiser for a safari trip. The vehicle was in perfect condition and the driver knew every road. Will definitely use again!"</p>
            <div class="mt-3 d-flex align-items-center">
              <div style="width:44px;height:44px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;color:#666;margin-right:12px;">S</div>
              <div>
                <strong>Sophie K.</strong><br>
                <small class="text-muted">Tourist, France</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="testimonial-card p-4 h-100" style="background:#fff; border-radius:12px; box-shadow:0 2px 16px rgba(0,0,0,0.07);">
            <div class="mb-3" style="color:#f5a623; font-size:18px;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <p style="font-style:italic;">"Affordable rates and very professional. I've used Kigali Airport Pickup three times now and they never disappoint. Great team!"</p>
            <div class="mt-3 d-flex align-items-center">
              <div style="width:44px;height:44px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;color:#666;margin-right:12px;">A</div>
              <div>
                <strong>Amara N.</strong><br>
                <small class="text-muted">NGO Worker, Rwanda</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="testimonial-card p-4 h-100" style="background:#fff; border-radius:12px; box-shadow:0 2px 16px rgba(0,0,0,0.07);">
            <div class="mb-3" style="color:#f5a623; font-size:18px;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <p style="font-style:italic;">"Arrived late at night and they were still there waiting. The booking process was simple and the WhatsApp communication was fast and easy."</p>
            <div class="mt-3 d-flex align-items-center">
              <div style="width:44px;height:44px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;color:#666;margin-right:12px;">D</div>
              <div>
                <strong>David O.</strong><br>
                <small class="text-muted">Conference Delegate, Kenya</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="testimonial-card p-4 h-100" style="background:#fff; border-radius:12px; box-shadow:0 2px 16px rgba(0,0,0,0.07);">
            <div class="mb-3" style="color:#f5a623; font-size:18px;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <p style="font-style:italic;">"Best car rental experience in Rwanda. Clean vehicles, fair prices and the team goes out of their way to make sure you're comfortable."</p>
            <div class="mt-3 d-flex align-items-center">
              <div style="width:44px;height:44px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;color:#666;margin-right:12px;">R</div>
              <div>
                <strong>Rachel T.</strong><br>
                <small class="text-muted">Solo Traveler, USA</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="testimonial-card p-4 h-100" style="background:#fff; border-radius:12px; box-shadow:0 2px 16px rgba(0,0,0,0.07);">
            <div class="mb-3" style="color:#f5a623; font-size:18px;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <p style="font-style:italic;">"Used them for a group trip to Volcanoes National Park. The Hiace van was spacious and comfortable. Driver was knowledgeable about Rwanda."</p>
            <div class="mt-3 d-flex align-items-center">
              <div style="width:44px;height:44px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;color:#666;margin-right:12px;">M</div>
              <div>
                <strong>Michael P.</strong><br>
                <small class="text-muted">Group Tour Organizer, Canada</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <footer class="ftco-footer ftco-bg-dark ftco-section">
    <div class="container">
      <div class="row mb-5">
        <div class="col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">About Kigali Airport Pick up</h2>
            <p>
              Far far away, behind the word mountains, far from the countries
              Vokalia and Consonantia, there live the blind texts.
            </p>
            <ul
              class="ftco-footer-social list-unstyled float-md-left float-lft mt-5"
            >
              <li class="">
                <a href="#"><span class="icon-twitter"></span></a>
              </li>
              <li class="">
                <a href="#"><span class="icon-facebook"></span></a>
              </li>
              <li class="">
                <a href="#"><span class="icon-instagram"></span></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="ftco-footer-widget mb-4 ml-md-5">
            <h2 class="ftco-heading-2">Information</h2>
            <ul class="list-unstyled">
              <li><a href="#" class="py-2 d-block">About</a></li>
              <li><a href="#" class="py-2 d-block">Services</a></li>
              <li><a href="#" class="py-2 d-block">Term and Conditions</a></li>
              <li><a href="#" class="py-2 d-block">Best Price Guarantee</a></li>
              <li>
                <a href="#" class="py-2 d-block"
                  >Privacy &amp; Cookies Policy</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">Customer Support</h2>
            <ul class="list-unstyled">
              <li><a href="#" class="py-2 d-block">FAQ</a></li>
              <li><a href="#" class="py-2 d-block">Payment Option</a></li>
              <li><a href="#" class="py-2 d-block">Booking Tips</a></li>
              <li><a href="#" class="py-2 d-block">How it works</a></li>
              <li><a href="#" class="py-2 d-block">Contact Us</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">Have a Questions?</h2>
            <div class="block-23 mb-3">
              <ul>
                <li>
                  <span class="icon icon-map-marker"></span
                  ><span class="text"
                    >RN 3 Street, Giporoso, Remera, Kigali Rwanda</span
                  >
                </li>
                <li>
                  <a href="#"
                    ><span class="icon icon-phone"></span
                    ><span class="text">+250 788 613 968</span></a
                  >
                </li>
                <li>
                  <a href="#"
                    ><span class="icon icon-envelope"></span
                    ><span class="text">info@kigaliairportspickup.com</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>
            All rights reserved | Kigali Airport Pickup
            <i class="icon-heart color-danger" aria-hidden="true"></i> by
            <a href="https://tambagroup.xyz" target="_blank">Tamba Group</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { computed, ref, reactive, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useHead } from '@vueuse/head'

useHead({
  title: 'Kigali Airport Pickup | Car Rental, Hotel Booking & Rwanda Transfers',
  meta: [
    { name: 'description', content: 'Kigali Airport Pickup – 24/7 airport transfers, car rental, and hotel booking in Rwanda. From Kigali International Airport to your hotel or any destination. Professional drivers, 15+ vehicles, affordable rates.' },
    { name: 'keywords', content: 'kigali airport pickup, kigali airport transfer, car rental kigali, kigali airport taxi, rwanda car hire, airport transfer rwanda, kigali hotel booking, rwanda hotel reservation, kigali accommodation, rwanda tourism car rental, gorilla trekking car hire, volcanoes national park transfer, kigali airport to hotel, hotel shuttle kigali, book hotel kigali, rwanda safari car rental, kigali travel transport' },
    { property: 'og:title', content: 'Kigali Airport Pickup | Car Rental, Hotel Booking & Rwanda Transfers' },
    { property: 'og:description', content: '24/7 airport transfers, car rental and hotel booking in Rwanda. Book from Kigali International Airport to your hotel or any destination.' },
    { property: 'og:url', content: 'https://kigaliairportspickup.com/' },
    { name: 'twitter:title', content: 'Kigali Airport Pickup | Car Rental, Hotel Booking & Rwanda Transfers' },
    { name: 'twitter:description', content: '24/7 airport transfers, car rental and hotel booking in Rwanda. Professional drivers, 15+ vehicles.' }
  ],
  link: [{ rel: 'canonical', href: 'https://kigaliairportspickup.com/' }],
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'Kigali Airport Pickup',
        description: 'Affordable, reliable 24/7 airport transfers, car rental, and hotel booking assistance in Kigali, Rwanda. Professional drivers and well-maintained fleet serving tourists, business travelers, and locals.',
        url: 'https://kigaliairportspickup.com',
        telephone: '+250788613968',
        email: 'info@kigaliairportspickup.com',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'RN 3 Street, Giporoso, Remera',
          addressLocality: 'Kigali',
          addressCountry: 'RW'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: -1.9536,
          longitude: 30.0606
        },
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '00:00',
          closes: '23:59'
        },
        priceRange: '$$',
        image: 'https://kigaliairportspickup.com/images/Kigali-International-Airport.jpg',
        sameAs: [
          'https://kigaliairportspickup.com'
        ],
        serviceArea: {
          '@type': 'City',
          name: 'Kigali'
        },
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Airport Transfer & Car Rental Services',
          itemListElement: [
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kigali Airport Transfer' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Car Rental Kigali Rwanda' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Rwanda Safari Car Hire' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Hotel Booking Assistance Kigali' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kigali Airport to Hotel Shuttle' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Gorilla Trekking Transport Rwanda' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Volcanoes National Park Transfer' } }
          ]
        }
      })
    },
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'How do I book a Kigali airport pickup?',
            acceptedAnswer: { '@type': 'Answer', text: 'Use the trip planning form on our website, click Book Now on any car, or contact us via WhatsApp at +250 788 613 968. We confirm instantly.' }
          },
          {
            '@type': 'Question',
            name: 'How much does a Kigali airport transfer cost?',
            acceptedAnswer: { '@type': 'Answer', text: 'Rates start from $25 per trip depending on the vehicle type and distance. Visit our Pricing page for full rate tables.' }
          },
          {
            '@type': 'Question',
            name: 'Do you operate 24 hours a day?',
            acceptedAnswer: { '@type': 'Answer', text: 'Yes, we operate 24/7, 365 days a year including nights, weekends, and public holidays.' }
          },
          {
            '@type': 'Question',
            name: 'Can I rent a car in Kigali without a driver?',
            acceptedAnswer: { '@type': 'Answer', text: 'Yes, self-drive car rental is available. A valid international driver\'s licence is required.' }
          },
          {
            '@type': 'Question',
            name: 'Which airport do you serve in Rwanda?',
            acceptedAnswer: { '@type': 'Answer', text: 'We primarily serve Kigali International Airport (KGL) and provide transfers to all destinations in Rwanda.' }
          },
          {
            '@type': 'Question',
            name: 'Do you help with hotel booking in Kigali?',
            acceptedAnswer: { '@type': 'Answer', text: 'Yes! We offer hotel booking assistance for all budgets – from affordable guesthouses to luxury hotels in Kigali and across Rwanda. Contact us via WhatsApp and we will find the best accommodation for your needs.' }
          }
        ]
      })
    }
  ]
})

const router = useRouter()

const images = [
  'images/kigali-international-airport-1.jpg',
  'images/kigali-landcruiserprado.jpeg',
  'images/IMG-20240413-WA0020-1.jpg',
  'images/Rwanda-Kigali-Airport-Taxis.jpg',
  'images/rangerover.jpg',
  'images/Airport-Transfers-Rwanda-Kigali.jpg',
  'images/maxresdefaulty-4x4-car-rental-rwanda-1.jpg',
  'images/23b5abc0-e7c9-4bcf-a898-be08aedb8e3d.jpeg',
  'images/prado.jpeg',
  'images/tourist-vehicle.jpeg',
  'images/rava4.jpeg',
  'images/car1.jpeg',
  'images/benz.jpeg',
  'images/landcruiser.jpeg',
  'images/car2.jpeg',
  'images/prado2.jpeg'
]

const currentImageIndex = ref(0)

let interval: number

onMounted(() => {
  interval = window.setInterval(() => {
    currentImageIndex.value =
      (currentImageIndex.value + 1) % images.length
  }, 3000) // Change every 5 seconds
})

onUnmounted(() => {
  clearInterval(interval)
})

// Define car data
const originalCars = ref([
  {
    name: 'RAVA 4 2021',
    type: '2021',
    image: '/images/kigali11.jpeg',
    price: 60
  },
  {
    name: 'RAV4',
    type: '2018',
    image: '/images/rwanda-car-rental-and.jpg',
    price: 25
  },
  {
    name: 'KIA SORENTO',
    type: '2018',
    image: '/images/kigali-kia.jpeg',
    price: 25
  },
  {
    name: 'LAND CRUISER TXL',
    type: 'Toyota',
    image: '/images/txl.jpg',
    price: 25
  },
  {
    name: 'Land Cruiser Airport Transfer',
    type: '2020',
    image: '/images/IMG-20240413-WA0020-1.jpg',
    price: 25
  },
  {
    name: 'LAND CRUISER PRADO',
    type: '2014',
    image: '/images/kigali-landcruiserprado.jpeg',
    price: 100
  },
  {
    name: 'TOURISM CAR',
    type: '2016',
    image: '/images/kigali-tourism.jpeg',
    price: 25
  },
  {
    name: 'TOYOTA HIACE VAN',
    type: 'VAN',
    image: '/images/kigali-van.jpeg',
    price: 25
  },
  {
    name: 'TOYOTA HIACE VAN',
    type: 'VAN',
    image: '/images/kigali-var-hiace.jpeg',
    price: 25
  },
  {
    name: 'KIA K5',
    type: 'VAN',
    image: '/images/kigali-k5.jpeg',
    price: 25
  },
  {
    name: 'RAVA 4',
    type: 'VAN',
    image: '/images/kigalirava444.jpeg',
    price: 25
  },
  {
    name: 'LANDCRUISER PRADO',
    type: 'VAN',
    image: '/images/prado2.jpeg',
    price: 25
  },
  {
    name: 'LANDCRUISER V8',
    type: 'VAN',
    image: '/images/landcruiser.jpeg',
    price: 25
  },
  {
    name: 'Tourist Vehicle',
    type: 'VAN',
    image: '/images/car1.jpeg',
    price: 25
  },
  {
    name: 'Mercedes Benz',
    type: 'VAN',
    image: '/images/benz.jpeg',
    price: 25
  },
  {
    name: 'LANDCRUISER PRADO EXL',
    type: 'VAN',
    image: '/images/xr.jpeg',
    price: 25
  },
  {
    name: 'KIA K5',
    type: 'VAN',
    image: '/images/kiak5.jpeg',
    price: 25
  }
])

document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('vimeoVideo') as HTMLVideoElement | null
  const modal = document.getElementById('vimeoModal')

  if (video && modal) {
    // Toggle play/pause on video click
    video.addEventListener('click', () => {
      if (video.paused) {
        video.play()
      } else {
        video.pause()
      }
    })

    // Pause when the modal is closed (Bootstrap 5 event)
    modal.addEventListener('hidden.bs.modal', () => {
      video.pause()
      video.currentTime = 0 // Optional: restart video on close
    })
  }
})

const tripDetails = reactive({
  pickupLocation: localStorage.getItem('pickupLocation') || '',
  dropoffLocation: localStorage.getItem('dropoffLocation') || '',
  pickupDate: localStorage.getItem('pickupDate') || '',
  dropoffDate: localStorage.getItem('dropoffDate') || '',
  pickupTime: localStorage.getItem('pickupTime') || ''
})

const findVehicle = () => {
  localStorage.setItem('pickupLocation', tripDetails.pickupLocation)
  localStorage.setItem('dropoffLocation', tripDetails.dropoffLocation)
  localStorage.setItem('pickupDate', tripDetails.pickupDate)
  localStorage.setItem('dropoffDate', tripDetails.dropoffDate)
  localStorage.setItem('pickupTime', tripDetails.pickupTime)
  setTimeout(() => {
    const vehicleSection = document.getElementById('vehicle')
    if (vehicleSection) {
      vehicleSection.scrollIntoView({ behavior: 'smooth' })
    }
  }, 200)
}

const cars = ref([...originalCars.value])

const selectedCarModel = ref<string | null>('All Car Models')
const selectedYear = ref<string | null>(null)
const selectedPrice = ref<number | null>(null)
const searchForm = ref<HTMLElement | null>(null)
const isSticky = ref(false)
const accommodation = ref<string | null>(null)

const accommodations = [
  { type: 'Budget', price: '30-50$', description: 'Affordable hotels and apartments.' },
  { type: 'Mid-Range', price: '50-100$', description: 'Comfortable stays with good amenities.' },
  { type: 'Luxury', price: '100$+', description: 'Premium hotels and exclusive homes.' }
]

const selectAccommodation = (type: string) => {
  accommodation.value = type
  localStorage.setItem('accommodation', type)
}

const uniquePrices = computed(() => {
  return [...new Set(originalCars.value.map(car => car.price))].sort((a, b) => a - b)
})

const carYears = computed(() => [...new Set(originalCars.value.map(car => car.type))].sort((a, b) => b - a))

/* Scroll to the vehicle section after search */
const searchCars = () => {
  cars.value = originalCars.value.filter((car) => {
    return (
      (selectedCarModel.value === 'all' || car.name === selectedCarModel.value) &&
      (!selectedYear.value || car.type === selectedYear.value) &&
        (!selectedPrice.value || car.price === selectedPrice.value)
    )
  })
  const section = document.getElementById('vehicle')
  if (section && searchForm.value) {
    window.scrollTo({
      top: section.offsetTop - searchForm.value.offsetHeight - 20,
      behavior: 'smooth'
    })
  }
  handleScroll()
}

/* Handle sticky search bar on scroll */
const handleScroll = () => {
  if (searchForm.value) {
    isSticky.value = window.scrollY > searchForm.value.offsetTop
  }
}

const saveCarDetails = (car: { name: string; type: string; image: string; price: number }) => {
  const carDetails = {
    name: car.name,
    type: car.type,
    image: car.image,
    price: car.price
  }
  localStorage.setItem('selectedCar', JSON.stringify(carDetails))
  router.push('/book/' + car.name.replace(/\s+/g, '-'))
}
</script>
<style scoped>
#accommodation {
  margin-top: 20px;
  padding: 20px;
  background: #f8f8f8;
  border-radius: 8px;
}
.accommodation-options {
  display: flex;
  gap: 20px;
}
.accommodation-card {
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.accommodation-card h3 {
  margin-bottom: 5px;
}
.hero-wrap {
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  display: flex;
  align-items: center;
  transition: background-image 1s ease-in-out;
}

@media (max-width: 768px) {
  .hero-wrap {
    min-height: 100vh; /* full height for mobile */
    background-size: cover;
    background-position: center center; /* prevent image cut-off */
  }
}

@media (max-width: 480px) {
  .hero-wrap {
    background-size: contain; /* or keep cover if needed */
    background-repeat: no-repeat;
    background-position: center top;
  }
}

.hero-wrap .container {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

@media (max-width: 768px) {
  .hero-wrap .container {
    padding: 1rem;
  }
}
.hero-wrap .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3); /* light black overlay */
  z-index: 1;
}

</style>
